import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Founders from "@/pages/Founders";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
        else if (el) el.scrollIntoView();
      }, 100);
    } else if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

const LenisRoot = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);
  return children;
};

function App() {
  return (
    <div className="grain min-h-screen bg-ink text-zinc-100">
      <LenisRoot>
        <BrowserRouter>
          <ScrollManager />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/founders" element={<Founders />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
      </LenisRoot>
    </div>
  );
}

export default App;
